import { t } from "@/i18n-js/instance";
import { Filter, InputFilter } from "@circle-react-shared/Filter";

interface NameFilterProps {
  onChange: (value: string) => void;
  value: string;
}

export const NameFilter = ({ value, onChange }: NameFilterProps) => (
  <Filter
    chip={t("settings.community_bot.knowledge.filters.name_chip")}
    title={t("settings.community_bot.knowledge.filters.name_title")}
    selectedText={value}
    onApply={val => onChange(val || "")}
    isInitialOpen={false}
    shouldShowRemoveButton
  >
    <InputFilter
      name="name-filter"
      placeholder={t(
        "settings.community_bot.knowledge.filters.name_search_placeholder",
      )}
      defaultValue={value}
    />
  </Filter>
);
